export const SET_BROWSER_DIMENSIONS = 'SET_BROWSER_DIMENSIONS';
